import React, { PureComponent } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import _ from "lodash";
import { Creators as CourseActions } from "../../../store/ducks/newCourse/actions";

import {gateway} from "../../../utils/api"

class Praticar extends PureComponent {
  endOfFile = () => {
    const idProfile = localStorage.getItem("idProfile")
    const { idCourse, selected, incrementCourseProgress } = this.props

    const progress = {
      idProfile,
      idTotvsCourse: idCourse,
      bbDiscipline: selected.idDiscipline,
      spxAttachment: selected.idAttachment,
      endOfFile: true,
    }

    const objectStatusProgress = _.get(selected, 'contentProgress.ox_status.wk_status', 'IN_PROGRESS');

    gateway
      .post("/userProgress/saveProgress", progress)
      .then(res => {
        console.log("RESPOSTA endOfFile", res.data)
        document.getElementById(selected.idAttachment).classList.add("active")
        if(objectStatusProgress !== "DONE") {
          incrementCourseProgress();
        }
      })
      .catch(err => console.log(err))
  }

  render() {
    return <div />
  }
}

const mapStateToProps = state => ({
  selected: state.course.selected,
  idCourse: state.course.data.idCourse,
})

const mapDispatchToProps = dispatch => bindActionCreators({...CourseActions}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Praticar)
